import React from 'react';
import { DefaultRecordType } from 'rc-table/lib/interface';

export const ReportDepCell = (value: any, record: DefaultRecordType) => (
  <React.Fragment>
    {value} {record.departureSecurityGateName}, {record.branchName}
  </React.Fragment>
);
